<template>
  <section>
    <GeneralTheme :theme="configuration">
      <CarouselCard
        v-if="carouselCard"
        v-bind="carouselCard"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import type { SectionBuilderCarouselCard } from '~/sanity/types';
import GeneralTheme from '../Themes/GeneralTheme.vue';
import CarouselCard from './CarouselCard.vue';
defineProps<SectionBuilderCarouselCard>();
</script>

<style></style>
